<template>
	<div class="skn-search-widget">
		<div class="skn-search-box">
			<input v-model="searchString" type="search" autocorrect="off" autocapitalize="off" autocomplete="off" spellcheck="false" required="required" maxlength="512" aria-label="Search" :placeholder="_placeholder" class="ais-SearchBox-input skn-search-input-field" @keyup.enter="doSearch">
			<button type="submit" title="Search" class="ais-SearchBox-submit" @click="doSearch">
				<svg role="img" xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 40 40" class="ais-SearchBox-submitIcon">
					<path d="M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z" fillRule="evenodd"></path>
				</svg>
			</button> 
			<button type="reset" title="Clear" hidden="hidden" class="ais-SearchBox-reset">
				<svg role="img" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" class="ais-SearchBox-resetIcon">
					<path d="M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z" fillRule="evenodd"></path>
				</svg>
			</button>
		</div>
		<div v-if="showSearchOverlay" class="lightbox search-overlay" :class="settingClass" ref="sknSearchWidgetLightbox">
			<div class="close-button" @click="hideSearchOverlay">
				<div class="close-button-graphics">
					<svg class="lightbox-close-cross" viewBox="0 0 100 100">
						<line x1="4" y1="4" x2="96" y2="96"></line>
						<line x1="4" y1="96" x2="96" y2="4"></line>
					</svg>
				</div>
			</div>
			<SearchComponent :search-index="searchIndex" :initial-search-string="searchString" :placeholder="placeholder" :base-path="basePath" :class="layoutClass" :show-image="showImage" :title-style="titleStyle" :subtitle-style="subtitleStyle" :description-style="descriptionStyle" :text-style="textStyle" :image-size="imageSize" :available-image-sizes="availableImageSizes"/>
		</div>
	</div>
  
</template>

<script>

import SearchComponent from './SearchComponent.vue';
//import 'instantsearch.css/themes/algolia-min.css';

export default {
	name: 'SknSearchWidget',
	components: {
		SearchComponent
	},
	props: {
		settingClass:{type:String, default:'search-setting-class'},
		titleStyle:{type:String, default:''},
		subtitleStyle:{type:String, default:''},
		descriptionStyle:{type:String, default:''},
		textStyle:{type:String, default:''},
		placeholder:{type:String, default:'Search products...'},
		searchIndex:{type: String, default: ''},
		basePath:{type: String, default: ''},
		layout:{type: String, default: 'grid'},
		showImage:{type: Boolean, default: true},
		imageSize:{type: [Number, String], default: 1366},
		availableImageSizes:{type: String, default: ''}
	},
	data() {
		return {
			searchString:'',
			showSearchOverlay: false
		};
	},
	computed:{
		_placeholder: function(){
			if(this.searchIndex == ''){
				return 'Error: Search index undefined';
			}
			else{
				return this.placeholder;
			}
		},
		layoutClass: function(){
			if(this.layout == "list"){
				return 'results-list';
			}
			return 'results-grid';
		}
	},
	methods:{
		doSearch: function(){
			if(this.searchString.length > 2){
				this.showSearchOverlay = true;
				var self = this;
				this.$nextTick(function () {
					document.body.appendChild(self.$refs.sknSearchWidgetLightbox);
					self.dispatchNotice();
				});
			}
		},
		dispatchNotice: function(){
			this.$emit('searchoverlayshown');
		},
		hideSearchOverlay: function(){
			this.showSearchOverlay = false;
			this.searchString = '';
		}
	}
}
</script>

<style>
	.skn-search-box{position:relative;}
	.lightbox, .lightbox *{box-sizing: border-box;}
	.lightbox.search-overlay{position:fixed; width:100vw; height:100vh; top:0; padding:30px; z-index:1000; left: 50%;  transform: translate(-50%, 0); box-shadow: 2px 2px 10px 2px rgba(0,0,0,0.5); width: 100vw;}
	.lightbox:before{content:''; position:absolute; top:0; left:0; width:100%; height:100%; background-color: rgba(255,255,255,1);}
	.lightbox .close-button{width: 60px; height: 60px; position: absolute; top: 0px; right: 0px; z-index: 500; cursor: pointer;}
	.lightbox .close-button-graphics{position: absolute; height: 24px; width:24px; font-size: 30px; top: 20px; right: 20px;
	background-color: #fff; background-color: rgba(255,255,255,0.85); border-radius: 50%; -webkit-filter: drop-shadow(0px 0px 3px rgba(0,0,0,1));
	filter: drop-shadow(0px 0px 3px rgba(0,0,0,1));    font-weight: 700; display: flex;  align-items: center; justify-content: center;}
	.lightbox-close-cross{width: 60%; height: 60%;}
	.lightbox-close-cross line{fill: none; stroke: currentColor; stroke-miterlimit: 16; stroke-width: 16px;}
	.lightbox .close-button:hover .close-button-graphics{background-color: #fff; background-color: rgba(255,255,255,1);}
	.ais-InstantSearch{width: 100%; height:100%;}
	.ais-Hits{height: calc(100% - 31px); overflow-y: auto; position: relative; padding-right: 1rem; padding-top: 1rem;}
	.ais-SearchBox{position:relative; padding-right: 2rem;}
	.ais-SearchBox-reset {right: 2rem;}
	.ais-SearchBox-input {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		padding: .3rem 1.7rem;
		width: 100%;
		position: relative;
		color: var(--search-text-color, #000000);
		background-color: var(--search-box-background-color, #fff);
		border: 1px solid var(--search-box-border-color, #c4c8d8);
		border-radius: var(--search-box-border-radius, 5px);
	}
	.ais-SearchBox-input::placeholder{color: var(--search-text-color, #000000);}
	.ais-SearchBox-submit {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		position: absolute;
		z-index: 1;
		width: 20px;
		height: 20px;
		top: 50%;
		left: .3rem;
		right: .3rem;
		transform: translateY(-50%);
		padding: 0;
		overflow: visible;
		font: inherit;
		line-height: normal;
		color: inherit;
		background: none;
		border: 0;
		cursor: pointer;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}
	.ais-SearchBox-submitIcon {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 14px;
		height: 14px;
		transform: translateX(-50%) translateY(-50%);
	}
	.ais-SearchBox-resetIcon path, .ais-SearchBox-submitIcon path {
		fill: var(--search-text-color, #495588);
	}
	.ais-SearchBox-reset{display:none;
		position: absolute;
		z-index: 1;
		width: 20px;
		height: 20px;
		top: 50%;
		right: .3rem;
		transform: translateY(-50%);
	}
	.ais-SearchBox-resetIcon {
		position: absolute;
		top: 50%;
		left: 50%;
		width: 12px;
		height: 12px;
		transform: translateX(-50%) translateY(-50%);
	}
	.item{position: relative;}
	.item img{width: 100%;}
	.item-link{	position: absolute; top: 0; right: 0; bottom:0; left: 0; z-index:10;}
	.skn-search-results{margin-left: 0; padding-left: 0; list-style: none;}
	.search-result-element{margin:0; padding:0;}
	.results-grid .skn-search-results{display: grid;}
	.results-list .skn-search-results{display: block;}
	.results-list .skn-search-result-item{padding-bottom: 5%;}
	.search-result-image{
		position: relative;
		width: 100%;
		background-color: #eeeeee;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: center center;
	}
	.search-result-title{display:block;}
	.search-result-subtitle{display:block;}
	.search-result-description{
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;  
		overflow: hidden;
	}
	.search-result-image.spacer{
		display: block;
	}

	.ais-Breadcrumb-list,.ais-CurrentRefinements-list,.ais-HierarchicalMenu-list,.ais-Hits-list,.ais-InfiniteHits-list,.ais-InfiniteResults-list,.ais-Menu-list,.ais-NumericMenu-list,.ais-Pagination-list,.ais-RatingMenu-list,.ais-RefinementList-list,.ais-Results-list,.ais-ToggleRefinement-list{margin:0;padding:0;list-style:none}.ais-ClearRefinements-button,.ais-CurrentRefinements-delete,.ais-CurrentRefinements-reset,.ais-GeoSearch-redo,.ais-GeoSearch-reset,.ais-HierarchicalMenu-showMore,.ais-InfiniteHits-loadMore,.ais-InfiniteHits-loadPrevious,.ais-InfiniteResults-loadMore,.ais-Menu-showMore,.ais-RangeInput-submit,.ais-RefinementList-showMore,.ais-SearchBox-reset,.ais-SearchBox-submit,.ais-VoiceSearch-button{padding:0;overflow:visible;font:inherit;line-height:normal;color:inherit;background:0 0;border:0;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ais-ClearRefinements-button::-moz-focus-inner,.ais-CurrentRefinements-delete::-moz-focus-inner,.ais-CurrentRefinements-reset::-moz-focus-inner,.ais-GeoSearch-redo::-moz-focus-inner,.ais-GeoSearch-reset::-moz-focus-inner,.ais-HierarchicalMenu-showMore::-moz-focus-inner,.ais-InfiniteHits-loadMore::-moz-focus-inner,.ais-InfiniteHits-loadPrevious::-moz-focus-inner,.ais-InfiniteResults-loadMore::-moz-focus-inner,.ais-Menu-showMore::-moz-focus-inner,.ais-RangeInput-submit::-moz-focus-inner,.ais-RefinementList-showMore::-moz-focus-inner,.ais-SearchBox-reset::-moz-focus-inner,.ais-SearchBox-submit::-moz-focus-inner,.ais-VoiceSearch-button::-moz-focus-inner{padding:0;border:0}.ais-ClearRefinements-button[disabled],.ais-CurrentRefinements-delete[disabled],.ais-CurrentRefinements-reset[disabled],.ais-GeoSearch-redo[disabled],.ais-GeoSearch-reset[disabled],.ais-HierarchicalMenu-showMore[disabled],.ais-InfiniteHits-loadMore[disabled],.ais-InfiniteHits-loadPrevious[disabled],.ais-InfiniteResults-loadMore[disabled],.ais-Menu-showMore[disabled],.ais-RangeInput-submit[disabled],.ais-RefinementList-showMore[disabled],.ais-SearchBox-reset[disabled],.ais-SearchBox-submit[disabled],.ais-VoiceSearch-button[disabled]{cursor:default}.ais-Breadcrumb-item,.ais-Breadcrumb-list,.ais-Pagination-list,.ais-PoweredBy,.ais-RangeInput-form,.ais-RatingMenu-link{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ais-GeoSearch,.ais-GeoSearch-map{height:100%}.ais-HierarchicalMenu-list .ais-HierarchicalMenu-list{margin-left:1em}.ais-PoweredBy-logo{display:block;height:1.2em;width:auto}.ais-RatingMenu-starIcon{display:block;width:20px;height:20px}.ais-SearchBox-input::-ms-clear,.ais-SearchBox-input::-ms-reveal{display:none;width:0;height:0}.ais-SearchBox-input::-webkit-search-cancel-button,.ais-SearchBox-input::-webkit-search-decoration,.ais-SearchBox-input::-webkit-search-results-button,.ais-SearchBox-input::-webkit-search-results-decoration{display:none}.ais-RangeSlider .rheostat{overflow:visible;margin-top:40px;margin-bottom:40px}.ais-RangeSlider .rheostat-background{height:6px;top:0;width:100%}.ais-RangeSlider .rheostat-handle{margin-left:-12px;top:-7px}.ais-RangeSlider .rheostat-background{position:relative;background-color:#fff;border:1px solid #aaa}.ais-RangeSlider .rheostat-progress{position:absolute;top:1px;height:4px;background-color:#333}.rheostat-handle{position:relative;z-index:1;width:20px;height:20px;background-color:#fff;border:1px solid #333;border-radius:50%;cursor:-webkit-grab;cursor:grab}.rheostat-marker{margin-left:-1px;position:absolute;width:1px;height:5px;background-color:#aaa}.rheostat-marker--large{height:9px}.rheostat-value{margin-left:50%;padding-top:15px;position:absolute;text-align:center;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.rheostat-tooltip{margin-left:50%;position:absolute;top:-22px;text-align:center;-webkit-transform:translateX(-50%);transform:translateX(-50%);}

</style>

